import * as React from "react";
import { css } from "@emotion/react";
import { FullScreenModalDialog } from "main/javascripts/components/molecules/Modal/FullScreenModalDialog";
import { ImageListWithThumbnail } from "main/javascripts/components/spot/ImageListWithThumbnail";
import { useAppDispatch, useAppSelector } from "main/javascripts/store";
import {
  hotelImagesSelector,
  isDisplayedImageModalSelector,
  setDisplayHotelImageModal,
} from "../hotelSlice";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

export interface IProps {
  imageData: any;
  isDisplayed: boolean;
}

export interface IActionsProps {
  actions: {
    setDisplayHotelImageModal: any;
  };
}

export const HotelImageModal: React.FC = (): React.ReactElement => {
  const appDispatch = useAppDispatch();

  const imageData = useAppSelector(hotelImagesSelector);
  const isDisplayed = useAppSelector(isDisplayedImageModalSelector);

  const closeHandler: () => void = () => {
    appDispatch(setDisplayHotelImageModal(false));
  };

  const imageListStyles = {
    exBlockStyle: slideBlockStyle,
    exGallerySliderStyle: gallerySliderBlockStyle,
  };

  return (
    // TODO: 旧コンポーネント使用中
    <FullScreenModalDialog displayed={isDisplayed} closeHandler={closeHandler}>
      {imageData && (
        <ImageListWithThumbnail images={imageData} styles={imageListStyles} />
      )}
    </FullScreenModalDialog>
  );
};

const slideBlockStyle = css`
  max-width: 90vw;
  max-height: 90vh;
`;

const gallerySliderBlockStyle = css`
  .swiper-wrapper {
    height: calc(70vh - 10rem);

    ${moreThanBreakpoint("desktop")} {
      height: calc(90vh - 10rem);
    }
  }
`;
